import importerActions from 'src/modules/shared/importer/importerActions';
import selectors from 'src/modules/indicator/importer/indicatorImporterSelectors';
import IndicatorService from 'src/modules/indicator/indicatorService';
import fields from 'src/modules/indicator/importer/indicatorImporterFields';
import { i18n } from 'src/i18n';

const indicatorImporterActions = importerActions(
  'INDICATOR_IMPORTER',
  selectors,
  IndicatorService.import,
  fields,
  i18n('entities.indicator.importer.fileName'),
);

export default indicatorImporterActions;